import { route } from "@helpers"
import useArchive from "@hooks/useArchive"
import PastSalon from "../components/PastSalon"

export default function usePastArchive(salons?: Interfaces.Salon[]) {
    const archive = useArchive(salons)

    archive.useComponent(PastSalon)
    archive.useEmpty({
        heading: "All your data from past salons will be saved here",
        description: "You haven't participated in any salon yet. You might choose a contest on \"Open Salons\" page.",
        button: {
            value: "See Salons",
            to: route("customer:current")
        }
    })

    return archive
}